module.exports = __webpack_public_path__ + "img/ico_libao.b2ef7cf3.png";